import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/(pages)/(home)/page.tsx");
